import React from 'react';
import { cn } from '@uconnect/assets/lib/utils';

export interface MessageProps extends React.HTMLAttributes<HTMLDivElement> {
	className?: string;
	children?: React.ReactNode;
}

export default function Message( { className, children, ...props }: MessageProps ) {
	return (
		<div
			{ ...props }
			data-component="message"
			className={ cn( '!p-3 rounded text-base bg-background wrap-anywhere relative', className ) }
		>
			{ children }
		</div>
	);
}
